import React from 'react';
import PropTypes from 'prop-types';
import { Container, HeadingLabel, HeadingItem } from './header-details-item.style';

/**
 * The Header Details Item component
 * @param {object} props - Object containing the props for this component
 * @param {string} props.label - Title for Details Item
 * @param {string} props.item - Content for Details Item
 * @return {element}
 */
const HeaderDetailsItem = ({ label, item }) => (
  <Container>
    <HeadingLabel>{label}</HeadingLabel>
    <HeadingItem>{item}</HeadingItem>
  </Container>
);

HeaderDetailsItem.propTypes = {
  label: PropTypes.string.isRequired,
  item: PropTypes.string,
};

HeaderDetailsItem.defaultProps = {
  item: '',
};

export default HeaderDetailsItem;
